import styled from "styled-components";

import type { ColorName } from "styles/config/colors";

export const SafeInput = styled.input<{
  $textColor?: ColorName;
  $placeholderColor?: ColorName;
}>`
  ${({ theme, $textColor }) =>
    $textColor && `color: ${theme.activeColorScheme.colors[$textColor]};`}

  ::placeholder {
    ${({ theme, $placeholderColor }) =>
      $placeholderColor &&
      `color: ${theme.activeColorScheme.colors[$placeholderColor]};`}
  }
`;
